import { useContext } from 'react';

import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import { MdOutlineWork } from 'react-icons/md';

import { CoreContext } from '../../../../context/CoreContext';

const ProductProviderTag = ({ providerName, variant = 'outline', maxW = 'fit-content', ...props }) => {
  const { coreData } = useContext(CoreContext);
  const { show_providers: showProductTeams } = coreData.booking_engine;

  if (!showProductTeams || !providerName) return <></>;

  return (
    <Tag size="sm" variant={variant} colorScheme="blue" mt="5px" maxW={maxW} wordBreak="break-all" {...props}>
      <TagLeftIcon as={MdOutlineWork} />
      <TagLabel>{providerName}</TagLabel>
    </Tag>
  );
};

export default ProductProviderTag;
